import { getProductVariants } from './productVariants';

const present = v => v !== null && v !== undefined && String(v).trim() !== '';
export const numericWeight = v => (typeof v === 'number' || typeof v === 'string') && present(v) && Number.isFinite(Number(v)) && Number(v) >= 0 ? Number(v) : null;
const missingWeight = v => !present(v) || (typeof v === 'string' && v.trim() === '未設定');
const weightOf = (product, variant) => {
  const raw = missingWeight(variant?.weight) ? product.weight : variant.weight;
  return missingWeight(raw) ? undefined : numericWeight(raw);
};

// The detail page uses the selected style's explicit weight, falling back to
// the product weight. Equal style values describe one product, not a sum.
export const productExportWeight = (product = {}, variants = getProductVariants(product), context = {}) => {
  if (product.subProducts?.length) {
    let total = 0;
    for (const [i, ref] of product.subProducts.entries()) {
      const child = context.subProducts?.[i]?.product;
      if (!child) return { value: null, issue: '組合商品缺少子商品重量依據，重量留白' };
      const choices = getProductVariants(child);
      const selected = ref.style && ref.style !== '--' ? choices.find(v => v.name === ref.style || v.style === ref.style) : choices[0];
      const weight = weightOf(child, selected), quantity = present(ref.quantity) ? numericWeight(ref.quantity) : 1;
      if (weight === null || quantity === null) return { value: null, issue: '組合商品重量或數量未設定，重量留白' };
      total += (weight ?? 0) * quantity;
    }
    return { value: Number.isFinite(total) ? total : null };
  }
  const resolved = (variants.length ? variants : [{}]).map(v => weightOf(product, v));
  if (resolved.includes(null)) return { value: null, issue: '商品重量無效，已留白' };
  const weights = [...new Set(resolved.filter(v => v !== undefined))];
  if (weights.length > 1) return { value: null, issue: `商品有不同重量（${weights.join('、')}），無法確定單一重量，已留白` };
  return { value: weights[0] ?? 0 };
};
